import React from 'react';
import { useIntl } from 'react-intl';

import TranslationButton from '../Components/DesignSystem/TranslationButton';
import useApiQuery from './useApiQuery';
import queriesConfig from '../Services/queriesConfig';
import Analytics from '../Services/AnalyticsService';
import Note from '../Utils/Types/Note';

export function useCommentTranslation(comment: Note, postId: any) {
  const intl = useIntl();
  const targetLang = intl.locale;
  const [fetchTranslation, setFetchTranslation] = React.useState(false);
  const [isShown, setIsShown] = React.useState(false);

  Analytics.track('Comment - Translation', {
    'Post ID': postId,
    'Comment ID': comment.id,
    fromLanguage: comment.lang,
    toLanguage: targetLang,
  });

  const { data, isLoading } = useApiQuery({
    onSuccess() {
      setIsShown(true);
    },
    query: queriesConfig.getCommentTranslation(comment?.id, targetLang),
    options: {
      enabled: fetchTranslation,
    },
  });

  const translatedContent = data ? (data as { content: string }).content : undefined;

  const translateButton = comment.lang !== targetLang && (
    <TranslationButton
      onClick={() => {
        setFetchTranslation(!translatedContent);
        if (translatedContent) {
          setIsShown(!isShown);
        }
      }}
      loading={isLoading}
      translated={Boolean(translatedContent) && isShown}
    />
  );

  const contentToShow = isShown ? translatedContent : comment.content;

  return {
    translateButton,
    content: contentToShow,
  };
}
